import { Autocomplete, TextField } from "@mui/material";

const Select = ({ label, options, getValue, value, error = false, helperText = "", inputRef }) => {
  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={options}
      value={value}
      onChange={(event, newValue) => getValue(newValue)}
      className="custom-select"
      isOptionEqualToValue={(option, value) => option === value}
      sx={{
        width: '100%',
        '& .MuiInputBase-root': {
          overflow: 'hidden',
        },
        '& .MuiAutocomplete-input': {
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        },
        ...(error && {
          '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d32f2f',
            borderWidth: '2px',
          },
          '& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d32f2f',
            boxShadow: '0 0 0 3px rgba(211, 47, 47, 0.18)',
          },
        }),
      }}
      renderOption={(props, option) => (
        <li {...props} style={{ whiteSpace: 'normal', wordBreak: 'break-word', fontSize: '14px' }}>
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef}
          label={label}
          error={Boolean(error)}
          helperText={helperText}
          className="custom-textfield"
          sx={{
            '& .MuiInputLabel-root': {
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              maxWidth: '90%',
            },
            '& .MuiFormHelperText-root.Mui-error': {
              fontWeight: 500,
              fontSize: '0.78rem',
              marginLeft: '4px',
            },
          }}
        />
      )}
    />
  );
};

export default Select;
